import { jsx } from "react/jsx-runtime";
const commonTriangleClasses = 'tw-absolute tw-border-solid';
const TopTriangle = ({ left })=>/*#__PURE__*/ jsx("div", {
        className: `${commonTriangleClasses} tw--top-0.4 tw-border-b-neutral-dark-700 dark:tw-border-b-neutral-light-200 tw-border-b-0.4 tw-border-x-transparent tw-border-x-0.4 tw-border-t-0`,
        style: {
            left: left || 8
        }
    });
const BottomTriangle = ({ left })=>/*#__PURE__*/ jsx("div", {
        className: `${commonTriangleClasses} tw--bottom-0.4 tw-border-t-neutral-dark-700 dark:tw-border-t-neutral-light-200 tw-border-t-0.4 tw-border-x-transparent tw-border-x-0.4 tw-border-b-0`,
        style: {
            left: left || 8
        }
    });
const LeftTriangle = ()=>/*#__PURE__*/ jsx("div", {
        className: `${commonTriangleClasses} tw--left-0.4 tw-border-solid tw-border-r-neutral-dark-700 dark:tw-border-r-neutral-light-200 tw-border-r-0.4 tw-border-y-transparent tw-border-y-0.4 tw-border-l-0`,
        style: {
            top: 'calc(100% / 2 - 4px)'
        }
    });
const RightTriangle = ()=>/*#__PURE__*/ jsx("div", {
        className: `${commonTriangleClasses} tw--right-0.4 tw-border-solid tw-border-l-neutral-dark-700 dark:tw-border-l-neutral-light-200 tw-border-l-0.4 tw-border-y-transparent tw-border-y-0.4 tw-border-r-0`,
        style: {
            top: 'calc(100% / 2 - 4px)'
        }
    });
const renderTriangleBasedOnCollisionsAndPosition = (collisions, position)=>{
    if ('top' === position) {
        if (collisions.top) {
            if (collisions.right) return /*#__PURE__*/ jsx(TopTriangle, {
                left: "calc(100% - 16px)"
            });
            return /*#__PURE__*/ jsx(TopTriangle, {});
        }
        if (collisions.bottom) {
            if (collisions.right) return /*#__PURE__*/ jsx(BottomTriangle, {
                left: "calc(100% - 16px)"
            });
        }
        if (collisions.right) return /*#__PURE__*/ jsx(BottomTriangle, {
            left: "calc(100% - 16px)"
        });
        return /*#__PURE__*/ jsx(BottomTriangle, {});
    }
    if ('bottom' === position) {
        if (collisions.bottom) {
            if (collisions.right) return /*#__PURE__*/ jsx(BottomTriangle, {
                left: "calc(100% - 16px)"
            });
            return /*#__PURE__*/ jsx(BottomTriangle, {
                left: 8
            });
        }
        if (collisions.right) return /*#__PURE__*/ jsx(TopTriangle, {
            left: "calc(100% - 16px)"
        });
        return /*#__PURE__*/ jsx(TopTriangle, {});
    }
    if ('left' === position) {
        if (collisions.left) {
            collisions.bottom;
            return /*#__PURE__*/ jsx(LeftTriangle, {});
        }
        return /*#__PURE__*/ jsx(RightTriangle, {});
    }
    if ('right' === position) {
        if (collisions.right) return /*#__PURE__*/ jsx(RightTriangle, {});
        return /*#__PURE__*/ jsx(LeftTriangle, {});
    }
    return null;
};
export { BottomTriangle, LeftTriangle, RightTriangle, TopTriangle, renderTriangleBasedOnCollisionsAndPosition };
